import { AvailabilitySlotsMap } from './types/types';

export const ALLOWED_DURATIONS = [15, 30, 60];

export const DEFAULT_DURATION = 30;

export const CALENDARS_TO_CHECK = ['primary'];
export const SLOT_PADDING = 0;
export const OWNER_TIMEZONE = 'Asia/Dubai';
export const LEAD_TIME = 0;

const WEEKEND_DAY = [
  {
    start: {
      hour: 11,
    },
    end: {
      hour: 23,
    },
  },
];
const DEFAULT_WORKDAY = [
  {
    start: {
      hour: 13,
      minute: 30,
    },
    end: {
      hour: 15,
      minute: 30,
    },
  },
];

export const OWNER_AVAILABILITY: AvailabilitySlotsMap = {
  0: WEEKEND_DAY,
  1: DEFAULT_WORKDAY,
  2: DEFAULT_WORKDAY,
  3: DEFAULT_WORKDAY,
  4: DEFAULT_WORKDAY,
  5: WEEKEND_DAY,
  6: WEEKEND_DAY,
};

export const LOCAL_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  weekday: 'long',
};

export const LOCAL_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
};
